import { CreateUpdateUserRequest } from '@src/main/modules/user/infrastructure/dto/createUpdateUserRequest';
import { createUserHttpRepository } from '@src/main/modules/user/infrastructure/UserHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const createUserUseCase = async (
  data: CreateUpdateUserRequest,
  tokenProvider: TokenProvider,
) => {
  const repository = createUserHttpRepository(tokenProvider);
  return await repository.create(data);
};
